import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { NotFoundComponent } from 'src/app/components/common/not-found/not-found.component';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { AuthGuard } from 'src/app/core/guard/auth.guard';
import { PermissionGuard } from 'src/app/core/guard/permission.guard';
import { permissionEntity } from 'src/app/core/constants/permission';
import { EventCalenderComponent } from '../components/event-calender/event-calender.component';
import { AllMoveMailListComponent } from '../mail-box/all-move-mail-list/all-move-mail-list.component';

const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.dashboard },
                loadChildren: () =>
                    import('../dashboard/dashboard.module').then(
                        (m) => m.DashboardModule
                    ),
            },
            {
                path: urlRoutes.dashboardmm,
                canActivate: [PermissionGuard],
                data: { permission: [permissionEntity.modules.dashboard, permissionEntity.modules.dashboardmm ]},
                loadChildren: () =>
                    import('../mm-dashboard/mm-dashboard.module').then(
                        (m) => m.MmDashboardModule
                    ),
            },
            {
                path: urlRoutes.dashboardrm,
                canActivate: [PermissionGuard],
                data: { permission: [permissionEntity.modules.dashboard, permissionEntity.modules.dashboardrm ]},
                loadChildren: () =>
                    import('../rm-dashboard/rm-dashboard.module').then(
                        (m) => m.RmDashboardModule
                    ),
            },
            {
                path: urlRoutes.dashboardrmwithOutpremission,
                loadChildren: () =>
                    import('../rm-dashboard-without-permission/rm-dashboard-without-permission.module').then(
                        (m) => m.RmDashboardWithoutPermissionModule
                    ),
            },
            {
                path: urlRoutes.dashboardurm,
                canActivate: [PermissionGuard],
                data: { permission: [permissionEntity.modules.dashboard, permissionEntity.modules.dashboardurm ]},
                loadChildren: () =>
                    import('../urm-dashboard/urm-dashboard.module').then(
                        (m) => m.UrmDashboardModule
                    ),
            },
            {
                path: urlRoutes.agent,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.agents },
                loadChildren: () =>
                    import('../agent-master/agents/agent.module').then(
                        (m) => m.AgentModule
                    ),
            },
            {
                path: urlRoutes.approved_agent,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.agents },
                loadChildren: () =>
                    import(
                        '../agent-master/approved-agent/approved-agent.module'
                    ).then((m) => m.ApprovedAgentModule),
            },
            {
                path: urlRoutes.non_approved_agent,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.non_approved_agent },
                loadChildren: () =>
                    import(
                        '../agent-master/non-approved-agent/non-approved-agent.module'
                    ).then((m) => m.NonApprovedAgentModule),
            },
            {
                path: urlRoutes.pending_bank_approval,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.agents },
                loadChildren: () =>
                    import(
                        '../agent-master/pending-bank-approval/pending-bank-approval.module'
                    ).then((m) => m.PendingBankApprovalModule),
            },
            {
                path: urlRoutes.inactive_agent,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.agents },
                loadChildren: () =>
                    import(
                        '../agent-master/inactive-agent/inactive-agent.module'
                    ).then((m) => m.InactiveAgentModule),
            },
            {
                path: urlRoutes.counsellor,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.counsellors },
                loadChildren: () =>
                    import('../agent-master/counsellor/counsellor.module').then(
                        (m) => m.CounsellorModule
                    ),
            },
            {
                path: urlRoutes.application_master,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.applications },
                loadChildren: () =>
                    import(
                        '../application-master/application-master.module'
                    ).then((m) => m.ApplicationMasterModule),
            },
            {
                path: urlRoutes.university_cat_cpt_art,
                canActivate: [PermissionGuard],
                data: {
                    permission: permissionEntity.modules.university_cat_cpt_art,
                },
                loadChildren: () =>
                    import(
                        '../university-master/university-cat-cpt-art/university-cat-cpt-art.module'
                    ).then((m) => m.UniversityCatCptArtModule),
            },
            {
                path: urlRoutes.university,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.university },
                loadChildren: () =>
                    import(
                        '../university-master/university/university.module'
                    ).then((m) => m.UniversityModule),
            },
            {
                path: urlRoutes.university_entry,
                canActivate: [PermissionGuard],
                data: {
                    permission:
                        permissionEntity.modules.universities_entry_requirement,
                },
                loadChildren: () =>
                    import(
                        '../university-master/university-entry/university-entry.module'
                    ).then((m) => m.UniversityEntryModule),
            },
            {
                path: urlRoutes.university_affliate,
                canActivate: [PermissionGuard],
                data: {
                    permission: permissionEntity.modules.university_affiliate,
                },
                loadChildren: () =>
                    import(
                        '../university-master/university-affiliate/university-affiliate.module'
                    ).then((m) => m.UniversityAffiliateModule),
            },
            {
                path: urlRoutes.university_process_link,
                canActivate: [PermissionGuard],
                data: {
                    permission:
                        permissionEntity.modules.universities_process_link,
                },
                loadChildren: () =>
                    import(
                        '../university-master/university-process-link/university-process.module'
                    ).then((m) => m.UniversityProcessModule),
            },
            {
                path: urlRoutes.university_filter_master,
                canActivate: [PermissionGuard],
                data: {
                    permission:
                        permissionEntity.modules.universities_filter_master,
                },
                loadChildren: () =>
                    import(
                        '../university-master/university-filter-master/university-filter-master.module'
                    ).then((m) => m.UniversityFilterMasterModule),
            },
            {
                path: urlRoutes.university_filter_pg,
                canActivate: [PermissionGuard],
                data: {
                    permission: permissionEntity.modules.university_filter_pg,
                },
                loadChildren: () =>
                    import(
                        '../university-master/university-pg/university-pg.module'
                    ).then((m) => m.UniversityPgModule),
            },
            {
                path: urlRoutes.university_filter_ug,
                canActivate: [PermissionGuard],
                data: {
                    permission: permissionEntity.modules.university_filter_ug,
                },
                loadChildren: () =>
                    import(
                        '../university-master/university-ug/university-ug.module'
                    ).then((m) => m.UniversityUgModule),
            },
            {
                path: urlRoutes.courses,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.courses },
                loadChildren: () =>
                    import('../courses-master/courses/courses.module').then(
                        (m) => m.CoursesModule
                    ),
            },
            {
                path: urlRoutes.options,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.options },
                loadChildren: () =>
                    import('../courses-master/options/options.module').then(
                        (m) => m.OptionsModule
                    ),
            },
            {
                path: urlRoutes.filters,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.filters },
                loadChildren: () =>
                    import('../courses-master/filters/filter.module').then(
                        (m) => m.FilterModule
                    ),
            },
            {
                path: urlRoutes.art,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.art_received },
                loadChildren: () =>
                    import('../art/art.module').then((m) => m.ARTModule),
            },
            {
                path: urlRoutes.form_master,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.filters },
                loadChildren: () =>
                    import('../form-master/form-master.module').then(
                        (m) => m.FormMasterModule
                    ),
            },
            {
                path: urlRoutes.mail_rules,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.admin_master },
                component: AllMoveMailListComponent
            },
            {
                path: urlRoutes.cat,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.cat },
                loadChildren: () =>
                    import('../CAT/cat.module').then((m) => m.CATModule),
            },
            {
                path: urlRoutes.cpt,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.cpt },
                loadChildren: () =>
                    import('../CPT/cpt.module').then((m) => m.CptModule),
            },
            {
                path: urlRoutes.cct,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.cct },
                loadChildren: () =>
                    import('../CCT/cct.module').then((m) => m.CCTModule),
            },
            {
                path: urlRoutes.notice_board,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.admin_notice_board },
                loadChildren: () =>
                    import('../notice-board/notice-board.module').then(
                        (m) => m.NoticeBoardModule
                    ),
            },
            {
                path: urlRoutes.admin_master,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.admin_master },
                loadChildren: () =>
                    import('../admin-master/admin.module').then(
                        (m) => m.AdminModule
                    ),
            },
            {
                path: urlRoutes.email_master,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.email_master },
                loadChildren: () =>
                    import('../email-master/email-master.module').then(
                        (m) => m.EmailMasterModule
                    ),
            },
            {
                path: urlRoutes.university_communications,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.filters },
                loadChildren: () =>
                    import(
                        '../university-communications/university-communications.module'
                    ).then((m) => m.UniversityCommunicationsModule),
            },
            {
                path: urlRoutes.tenant,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.store },
                loadChildren: () =>
                    import('../store-master/tenent/tenent.module').then(
                        (m) => m.TenentModule
                    ),
            },
            {
                path: urlRoutes.subTenant,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.sub_store },
                loadChildren: () =>
                    import('../store-master/sub-tenent/sub-tenent.module').then(
                        (m) => m.SubTenentModule
                    ),
            },
            {
                path: urlRoutes.permissions,
                loadChildren: () =>
                    import('../permissions/permissions.module').then(
                        (m) => m.PermissionsModule
                    ),
            },
            {
                path: urlRoutes.master_tools,
                loadChildren: () =>
                    import('../master-tool/master-tool.module').then(
                        (m) => m.MasterToolModule
                    ),
            },
            {
                path: urlRoutes.application_status,
                loadChildren: () =>
                    import('../application-statuss/statuses.module').then(
                        (m) => m.ApplicationStatussModule
                    ),
            },
            {
                path: urlRoutes.link_builder,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.link_builder },
                loadChildren: () =>
                    import('../link-builder/link-builder.module').then(
                        (m) => m.LinkBuilderModule
                    ),
            },
            {
                path: urlRoutes.bank_mail_details,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.bank_mail_details },
                loadChildren: () =>
                    import('../bank-mail-details/bank-mail-details.module').then(m => m.BankMailDetailsModule)
            },
            {
                path: urlRoutes.ip_details,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.ip_details },
                loadChildren: () =>
                    import('../ip-details/ip-details.module').then(
                        (m) => m.IpDetailsModule
                    ),
            },
            {
                path: urlRoutes.users,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.users },
                loadChildren: () =>
                    import('../backend-users/users/users.module').then(
                        (m) => m.UsersModule
                    ),
            },
            {
                path: urlRoutes.users_groups,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.user_groups },
                loadChildren: () =>
                    import(
                        '../backend-users/user-groups/user-groups.module'
                    ).then((m) => m.UserGroupsModule),
            },
            {
                path: urlRoutes.finance,
                loadChildren: () =>
                    import('../finance/finance.module').then(
                        (m) => m.FinanceModule
                    ),
            },
            {
                path: urlRoutes.profile,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.profile },
                loadChildren: () =>
                    import('../profile/profile.module').then(
                        (m) => m.ProfileModule
                    ),
            },
            {
                path: urlRoutes.mail_details,
                loadChildren: () =>
                    import('../read-mail/read-mail.module').then(
                        (m) => m.ReadMailModule
                    ),
            },
            {
                path: urlRoutes.file_manager,
                loadChildren: () =>
                    import('../file-manager/file-manager.module').then(
                        (m) => m.FileManagerModule
                    ),
            },
            {
                path: urlRoutes.mail_box,
                canActivate: [PermissionGuard],
                data: { permission: permissionEntity.modules.mail_box },
                loadChildren: () =>
                    import('../mail-box/mail-box.module').then(
                        (m) => m.MailBoxModule
                    ),
            },
            {
                path: urlRoutes?.notification_master,
                loadChildren: () =>
                    import('../notification/notification.module').then(
                        (m) => m.NotificationModule
                    ),
            },
            {
                path: 'forms',
                loadChildren: () => import('../automation-forms/automation-forms.module').then((m) => m.AutomationFormsModule)
            },
            {
                path: urlRoutes?.chat_master,
                loadChildren: () =>
                    import('../chat/chat.module').then((m) => m.ChatModule),
            },
            {
                path: urlRoutes?.reports,
                loadChildren: () =>
                    import('../reports/reports.module').then((m) => m.ReportsModule),
            },
            {
                path: urlRoutes?.automation,
                loadChildren: () =>
                    import('../automation/automation.module').then((m) => m.AutomationModule),
            },
            //New
            { 
                path:  urlRoutes?.application_automation_log, 
                loadChildren: () => 
                    import('../activity-log/activity-log.module').then(m => m.ActivityLogModule) 
            },
            { 
                path: 'automation-log', loadChildren: () => import('../automation-log/automation-log.module').then(m => m.AutomationLogModule) 
            },
            { 
                path: 'event', component: EventCalenderComponent
            },
            {
                path: urlRoutes?.referred_qc,
                loadChildren: () =>
                    import('../referre-qc/referre-qc.module').then((m) => m.ReferreQcModule),
            },
            {
                path: urlRoutes?.call_logs,
                loadChildren: () =>
                  import('../call-logs/call-logs.module').then((m) => m.CallLogsModule),
            },

            {
                path: urlRoutes?.ai_interview_logs,
                loadChildren: () =>
                  import('../ai-interview-logs/ai-interview-logs.module').then((m) => m.AiInterviewLogsModule),
            },
            
            {
                path: urlRoutes?.archived,
                loadChildren: () =>
                    import('../application-master/archived-list/archived-list.module').then((m) => m.ArchivedListModule),
            },
            {
                path: urlRoutes?.admin_voucher,
                data: { permission: permissionEntity.modules.voucher },
                loadChildren: () =>
                    import('../admin-master/voucher/voucher.module').then((m) => m.VoucherModule),
            },
            {
                path: urlRoutes?.search_agent,
                data: { permission: permissionEntity.modules.agents },
                loadChildren: () =>
                    import('../agent-search/searchAgent/search-agent.module').then((m) => m.SearchAgentModule),
            },
            {
                path: urlRoutes.accommodation,
                data: { permission: permissionEntity.modules.cabin },
                loadChildren: () => 
                    import('../admin-master/accommodation/accommodation.module').then((m) => m.AccommodationModule)
            }
        ],
    },
    

    // This line will remain down from the whole pages component list
    { path: '**', component: NotFoundComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LayoutRoutingModule { }
